export const COLUMN_TYPES = {
    string: 'string',
    number: 'number',
    bool: 'bool',
    date: 'date',
    select: 'select',
    container: 'container', //special case
    currency: 'currency'
}


// WEBPACK FOOTER //
// ./src/app/contants/COLUMN_TYPES.ts